const ParticipatedIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.6663 8.3321C14.6663 8.0045 14.6628 7.3435 14.6558 7.01496C14.6123 4.97127 14.5905 3.94943 13.8364 3.19247C13.0823 2.43552 12.0328 2.40915 9.93381 2.35641C8.64014 2.32391 7.35921 2.32391 6.06555 2.35641C3.96656 2.40914 2.91706 2.43551 2.16297 3.19247C1.40889 3.94942 1.3871 4.97126 1.34351 7.01496C1.3295 7.6721 1.32951 8.3253 1.34352 8.98243C1.3871 11.0262 1.40889 12.048 2.16298 12.805C2.91706 13.5619 3.96656 13.5882 6.06556 13.641C6.60073 13.6544 7.13374 13.6623 7.66634 13.6646"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.66699 5.66797L6.62834 6.82757C7.77179 7.50364 8.22886 7.50364 9.37232 6.82757L11.3337 5.66797"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M14.6663 11.6667H9.33301M14.6663 11.6667C14.6663 11.1999 13.3368 10.3277 12.9997 10M14.6663 11.6667C14.6663 12.1335 13.3368 13.0057 12.9997 13.3333"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default ParticipatedIcon;
